import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { listRegion } from '../../datas/DatasActions'
import { updateProvider, createNewLeadProvider, retrieveProvider} from '../ProviderActions'
import FormStepOne from '../components/FormStepOne'
import { asyncValidateUsernameNotExists  } from '../../utils/forms/validators'
import { parseValueProvider } from '../../utils/parse'

import { addNotifSuccess, addNotifError } from '../../notification/NotificationActions'

const mapStateToProps = (state) => {

    return {
  		regions : state.datas.regions,
        user : state.user,
        provider : state.provider.provider,
        initialValues: null
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        listRegion: () => {
            return dispatch(listRegion())
        }
    }
}

const config = {
    form: 'FormStepNewForm',
    onSubmit: (values, dispatch, props) => {
        window.scrollTo(0, 0);

        return dispatch(createNewLeadProvider(values))
            .then((response) => {

                dispatch(retrieveProvider(response.action.payload.data.id))
                    .then((response) => {
                        props.nextPage()
                    })
                    .catch((error) => {
                        dispatch(addNotifError("Erreur", "Veuillez recommencer."))
                    })

            })
            .catch((error) => {
                dispatch(addNotifError("Erreur", "Veuillez recommencer."))
            })

    },
    asyncValidate: asyncValidateUsernameNotExists,
    asyncBlurFields: ['username'],
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(config)(FormStepOne))



// WEBPACK FOOTER //
// ./src/provider/containers/FormStepNewContainer.js